import "../styles/neo-ui.component.scss";
import { useRef, useState } from "react";
import { BsArrowRightSquare } from "react-icons/bs";
import NeoImageModal, { NeoImageModalParagraph, NeoImageModalTitle } from "../components/modals/NeoImageModal";
import { NeoSplitBannerTitle, NeoSplitSlide, NeoSplitCarouselContainer, NeoSplitBannerSubtitle, NeoSplitBanner } from "../components/ui/NeoSplitCarouselContainer";
import NeoPageLayout from "../components/ui/NeoPageLayout";
import { NeoJumbotron } from "../components/ui/NeoJumbotron";
import { useNavigate } from "react-router-dom";
import { useHttpClient } from "../utils/http.utils";
import { Validators } from "../utils/validators.utils";
import hotToast from "react-hot-toast"

export default function LandingPage() {
    const [activeTab, setActiveTab] = useState(0);
    const navigate = useNavigate();
    const { joinWaitListApi } = useHttpClient();
    const [showWhiteRabbitModal, setShowWhiteRabbitModal] = useState(false);
    const [showSlideFourthModal, setShowSlideFourthModal] = useState(false);
    const contactUsInputRef = useRef<HTMLInputElement>(null);
    const [isLoading, setIsPageLoading] = useState(true);

    const changeTab = (pageIndex: number = -1, direction = 1) => {
        // direction can either be 1 or -1
        let index: number;

        if (pageIndex > -1) {
            index = pageIndex;
        } else {
            if (activeTab === 0 && direction === -1) {
                index = 0;
            } else {
                index = activeTab + direction;
            }
        }

        // const anchors = document.querySelectorAll(".landing-nav-link");

        // anchors.forEach((a) => a.classList.remove("active"));

        const navbar = document.getElementById("navbar");
        const navbarLinks: HTMLCollectionOf<HTMLUListElement> = document.getElementsByClassName("landing-nav-link") as HTMLCollectionOf<HTMLUListElement>;
        // remove white bg
        navbar?.classList.remove("white-bg");
        navbar?.classList.remove("dark-bg");
        // reset the style color of the navbarLinks to #565869
        for (let i = 0; i < navbarLinks.length; i++) {
            if (navbarLinks.item(i)) {
                navbarLinks.item(i)!.style.color = "#565869";
            }
        }

        /**
         * Scroll back to banner horizontal slide shows
         */
        if (activeTab >= 4 && index < 4) {
            document.querySelector("#banner")?.scrollIntoView({
                behavior: "smooth",
            });
        }

        switch (index) {
            case 0:
                break;
            case 1:
                break;
            case 3:
                break;
            case 4:
                // set the nav links to white
                for (let i = 0; i < navbarLinks.length; i++) {
                    if (navbarLinks.item(i)) {
                        navbarLinks.item(i)!.style.color = "#FFFFFF";
                    }
                }
                // document.getElementById("products-link")?.classList.add("active");
                document.querySelector("#page_5")?.scrollIntoView({
                    behavior: "smooth",
                });
                break;
            case 5:
                navigate("/project-x");
                break;
            // case 6:
            //     // document.getElementById("lootverse-link")?.classList.add("active");
            //     // scroll to collaboration page
            //     document.querySelector("#articles")?.scrollIntoView({
            //         behavior: "smooth",
            //     });
            //     // show black neo-logo by adding the white bg variant of the navbar
            //     setTimeout(() => {
            //         navbar?.classList.add("white-bg");
            //     }, 500);

            //     break;
            // case 7:
            //     // document.getElementById("lootverse-link")?.classList.add("active");
            //     // scroll to collaboration page
            //     document.querySelector("#team")?.scrollIntoView({
            //         behavior: "smooth",
            //     });
            //     // show black neo-logo by adding the white bg variant of the navbar
            //     setTimeout(() => {
            //         navbar?.classList.add("white-bg");
            //     }, 500);

            //     break;
        }

        setActiveTab(index);
    };

    /**
     * This function fires when the first image loads
     */
    const onFirstImageLoad = () => {
        setIsPageLoading(false);
    };

    const scrollSectionIntoView = (sectionId: string) => {
        document.querySelector(sectionId)?.scrollIntoView({
            behavior: "smooth",
        });
    }

    const onEnterEmail = (e: any) => {
        /**
         * Check if enter key was pressed
         */
        if (e.keyCode !== 13) {
            return;
        }

        const input = contactUsInputRef.current,
            inputValue = input!.value;

        if (!inputValue) {
            return;
        }

        const email = inputValue.trim();

        if (!Validators.validateEmail(email)) {
            hotToast.error("Please provide a valid email");
            return;
        }

        let toastId = hotToast.loading("Saving your email");
        // Add to database
        joinWaitListApi({ email: email, platform: "ats_website" })
            .then(({ data }) => {
                if (data["success"] === false) {
                    // If the user is already in the waitlist
                    if (data?.error[0].code === 5902) {
                        hotToast.error("You are already on the list. We will get to you shortly.", {
                            id: toastId,
                        });
                    } else {
                        hotToast.error("Cannot save your email at this time. Please try again later", {
                            id: toastId,
                        });
                    }

                } else {
                    hotToast.success("Your email has been saved. We will get back to you shortly", {
                        id: toastId,
                    });
                    // clear input
                    input!.value = "";
                }
            })
            .catch(err => {
                console.error(err?.error)
                hotToast.error("Cannot save your email at this time. Please try again later", {
                    id: toastId,
                });
            })
    }

    return (
        <>
            <NeoPageLayout
                pageTitle="Home - ATS Global"
                pageDescription="Complete and Tailored AI Solutions"
                isLoading={isLoading}
                logoUrl={{
                    white: "/ATS_Global_Branding_SansNeo_White.png",
                    black: "ATS_Global_Branding_SansNeo_Black.png"
                }}
                logoStyle={{
                    height: "65px",
                }}
                logoAction={"/"}
                links={[
                    {
                        title: "project x",
                        action: "/project-x",
                    },
                    {
                        title: "about",
                        action: "/about",
                    },
                    // {
                    //     title: "blog",
                    //     action: "/blog",
                    // },
                    {
                        title: "team",
                        action: "/team",
                    },
                    {
                        title: "contact us",
                        action: "/contact-us",
                    },
                ]}
                mobileFooterLinks={[
                    {
                        title: "NeoAI",
                        action: "https://neoworlder.ai",
                    },
                    {
                        title: "NeoWorlder",
                        action: "https://neoworlder.com",
                    },
                    {
                        title: "Lootverse",
                        action: "https://lootverse.com",
                    },
                ]}
            >
                <NeoSplitCarouselContainer id="banner" onImageLoaded={onFirstImageLoad} onNavigate={() => changeTab(4)}>
                    <NeoSplitSlide
                        imageUrl="/WEBSITE_PAGE1.jpeg"
                        hideBackBtn={true}
                        textContainerStyle={{ width: "703px" }}
                        smButtonClass="bg-white text-black"
                    >
                        <NeoSplitBanner className="first-slide">
                            <NeoSplitBannerTitle className="lg hidden md:block">Tailored AI Solutions</NeoSplitBannerTitle>
                            <NeoSplitBannerTitle className="sm block md:hidden">
                                Tailored AI Solutions
                            </NeoSplitBannerTitle>
                            <NeoSplitBannerSubtitle className="lg">Think It. Deploy It.</NeoSplitBannerSubtitle>
                        </NeoSplitBanner>
                    </NeoSplitSlide>

                    <NeoSplitSlide
                        imageUrl="/WEBSITE_PAGE2.jpeg"
                        smButtonClass="bg-white text-black"
                    >
                        <NeoSplitBanner>
                            <NeoSplitBannerTitle className="lg hidden md:block">Bridging Worlds</NeoSplitBannerTitle>
                            <NeoSplitBannerTitle className="sm md:hidden">Bridging Worlds</NeoSplitBannerTitle>
                            <NeoSplitBannerSubtitle className="lg hidden md:block">
                                We dream of a future where technology doesn't <br /> just work for us - it works with us.
                            </NeoSplitBannerSubtitle>
                            <NeoSplitBannerSubtitle className="subtitle-larger sm block md:hidden">
                                We dream of a future where technology doesn't <br /> just work for us - it works with us.
                            </NeoSplitBannerSubtitle>
                        </NeoSplitBanner>
                    </NeoSplitSlide>

                    <NeoSplitSlide
                        imageUrl="/slide_3.jpeg"
                        popupAction={() => setShowWhiteRabbitModal(true)}
                        textContainerStyle={{ width: "811px" }}
                        smButtonClass="bg-white text-black"
                    >
                        <NeoSplitBanner>
                            <NeoSplitBannerTitle>Outperform with AI</NeoSplitBannerTitle>

                            <NeoSplitBannerSubtitle>
                                Embrace limitless potential.
                            </NeoSplitBannerSubtitle>
                        </NeoSplitBanner>
                    </NeoSplitSlide>

                    <NeoSplitSlide
                        imageUrl="/WEBSITE_PAGE3.jpeg"
                        popupAction={() => setShowSlideFourthModal(true)}
                        smButtonClass="bg-white text-black"
                    >
                        <NeoSplitBanner>
                            <NeoSplitBannerTitle>Unlock The Future, Today</NeoSplitBannerTitle>
                            <NeoSplitBannerSubtitle className="md:hidden">Humans and AI interactions have never been this powerful.</NeoSplitBannerSubtitle>
                            <NeoSplitBannerSubtitle className="hidden md:block">
                                Humans and AI interactions have never been this powerful.
                            </NeoSplitBannerSubtitle>
                        </NeoSplitBanner>
                    </NeoSplitSlide>
                </NeoSplitCarouselContainer>

                <NeoJumbotron
                    id="page_5"
                    theme="dark"
                    title={
                        <span>
                            Welcome to a world where technology <br /> and people evolve together.
                        </span>
                    }
                    subtitle={
                        <>
                            <p>
                                A world where AI not only assists, but inspires.
                            </p>
                            <p>
                                Join us as we reimagine what's possible - together.
                            </p>
                        </>
                    }
                    backgroundImage="/spiral_bg.png"
                    onNavigate={() => changeTab(5)}
                    onNavigateBack={() => changeTab(3)}
                />

            </NeoPageLayout>


            <NeoImageModal isOpen={showWhiteRabbitModal} textLength="short" onClose={() => setShowWhiteRabbitModal(false)} theme="dark" imageUrl="/WEBSITE_PAGE4.jpeg" textContainerWidth={"564px"}>
                <NeoImageModalTitle style={{ fontSize: "34px" }}>Introducing Personas, our artificially intelligent workers:</NeoImageModalTitle>
                {/* <NeoImageModalParagraph>There are many ways to engineer creativity and intelligence on Neo. You can:</NeoImageModalParagraph> */}
                <NeoImageModalParagraph>
                    <p className="modal-arrow-poin-paragraph">
                        <div className="first-col">
                            <BsArrowRightSquare className="icon" />
                        </div>
                        <div className="">
                            Imagine AI that doesn't just assist but understands and reasons like a human.
                        </div>
                    </p>
                </NeoImageModalParagraph>
                <NeoImageModalParagraph>
                    <p className="modal-arrow-poin-paragraph">
                        <div className="first-col">
                            <BsArrowRightSquare className="icon" />
                        </div>
                        <div className="">An AI that can think, choose, act and relate.</div>
                    </p>
                </NeoImageModalParagraph>
                <NeoImageModalParagraph>
                    <p className="modal-arrow-poin-paragraph">
                        <div className="first-col">
                            <BsArrowRightSquare className="icon" />
                        </div>
                        <div className="">With each interaction, they evolve - to understand you. Your history. Knowledge. Preferences.</div>
                    </p>
                </NeoImageModalParagraph>
                <NeoImageModalParagraph>
                    <p className="modal-arrow-poin-paragraph">
                        <div className="first-col">
                            <BsArrowRightSquare className="icon" />
                        </div>
                        <div className="">
                            These Personas become like clones of your business identity. They absorb the culture and vision, breaking down the
                            silos between humans and machines.
                        </div>
                    </p>

                </NeoImageModalParagraph>
                <NeoImageModalParagraph>
                    <p className="modal-arrow-poin-paragraph">
                        <div className="first-col">
                            <BsArrowRightSquare className="icon" />
                        </div>
                        <div className="">
                            Our purpose has always been to amplify human potential by enhancing human intelligence,
                            just like a microphone enhances a voice.
                        </div>
                    </p>

                </NeoImageModalParagraph>
                <NeoImageModalParagraph>
                    <p className="modal-arrow-poin-paragraph">
                        <div className="first-col">
                            <BsArrowRightSquare className="icon" />
                        </div>
                        <div className="">
                            The future awaits. Let's meet it together.
                        </div>
                    </p>

                </NeoImageModalParagraph>
            </NeoImageModal>

            <NeoImageModal isOpen={showSlideFourthModal} textLength="short" onClose={() => setShowSlideFourthModal(false)} theme="dark" imageUrl="/WEBSITE_PAGE7.jpeg" textContainerWidth={"564px"}>
                <NeoImageModalTitle style={{ fontSize: "36px" }}>The Power of AI Assistants</NeoImageModalTitle>

                <NeoImageModalParagraph>
                    <p className="modal-arrow-poin-paragraph">
                        <div className="first-col">
                            <BsArrowRightSquare className="icon" />
                        </div>
                        <div className="">
                            <p className="font-bold">Maximized Business Growth:</p>
                            Advanced AI significantly boosts your number of leads, customers, and overall revenue.
                        </div>
                    </p>
                </NeoImageModalParagraph>
                <NeoImageModalParagraph>
                    <p className="modal-arrow-poin-paragraph">
                        <div className="first-col">
                            <BsArrowRightSquare className="icon" />
                        </div>
                        <div className="">
                            <p className="font-bold">Genuine Customer Relationships:</p>
                            Utilize personalized engagement for deeper connections.
                        </div>
                    </p>

                </NeoImageModalParagraph>
                <NeoImageModalParagraph>
                    <p className="modal-arrow-poin-paragraph">
                        <div className="first-col">
                            <BsArrowRightSquare className="icon" />
                        </div>
                        <div className="">
                            <p className="font-bold">Smart Lead Handling:</p>
                            Innovate lead generation and outreach with detailed conversation data to
                            reach out to leads more effectively.
                        </div>
                    </p>

                </NeoImageModalParagraph>
                <NeoImageModalParagraph>
                    <p className="modal-arrow-poin-paragraph">
                        <div className="first-col">
                            <BsArrowRightSquare className="icon" />
                        </div>
                        <div className="">
                            <p className="font-bold">Strengthened Customer Loyalty:</p>
                            Keep customers coming back by accompanying customers at every step of their journey.
                        </div>
                    </p>
                </NeoImageModalParagraph>
                <NeoImageModalParagraph>
                    <p className="modal-arrow-poin-paragraph">
                        <div className="first-col">
                            <BsArrowRightSquare className="icon" />
                        </div>
                        <div className="">
                            <p className="font-bold">Easy to Use and Efficient:</p>
                            Experience seamless integration and expert-optimized AI that works from the start.
                        </div>
                    </p>
                </NeoImageModalParagraph>
                {/* <NeoImageModalParagraph>There are many ways to engineer creativity and intelligence on Neo. You can:</NeoImageModalParagraph> */}

            </NeoImageModal>
        </>

    );
}
